var keyMirror = require('keymirror');

module.exports = keyMirror({
  TYPE_OPEN: null,
  TYPE_DISCONNECT: null,
  TYPE_CLOSE: null,
  TYPE_MESSAGE: null,
  TYPE_ERROR: null
});



/** WEBPACK FOOTER **
 ** ./src/constants/MessageConstants.js
 **/